import { ReactNode } from "react";

/**
 * Global App Providers
 * Extend this as needed:
 * - Zustand devtools
 * - Theme providers
 * - Feature flags
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <>
      {children}
    </>
  );
}